"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_CONSTANTS = void 0;
exports.TIME_CONSTANTS = {
    THREE_HOURS: 1000 * 60 * 60 * 3,
    TWELVE_HOURS: 1000 * 60 * 60 * 12,
    ONE_DAY: 1000 * 60 * 60 * 24,
    SEVEN_DAYS: 1000 * 60 * 60 * 24 * 7,
    TWO_WEEKS: 1000 * 60 * 60 * 24 * 7 * 2
};
